import { useCallback } from 'react';

import { Modal } from 'ui';

import { AddStudentModal } from './AddStudentModal';
import { StudentAddedModal } from './StudentAddedModal';
import { AddStudentModalStack as AddStudentModalStackEnum } from './types';
import { useAddStudentModalStack } from './useAddStudentModalStack';

type AddStudentModalStackProps = {
  stack: ReturnType<typeof useAddStudentModalStack>['stack'];
};

const AddStudentModalStack = ({ stack }: AddStudentModalStackProps) => {
  const openStudentAddedModal = useCallback(() => {
    stack.open(AddStudentModalStackEnum.StudentAdded);
  }, [stack]);

  return (
    <Modal.Stack>
      <AddStudentModal
        {...stack.register(AddStudentModalStackEnum.AddStudent)}
        openStudentAddedModal={openStudentAddedModal}
      />
      <StudentAddedModal
        {...stack.register(AddStudentModalStackEnum.StudentAdded)}
        onGoToStudents={() => {
          stack.closeAll();
        }}
      />
    </Modal.Stack>
  );
};

export { AddStudentModalStack };
